// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__328Ln","fadeIn":"Logo_fadeIn__124Dj","Title":"Logo_Title__3AuFQ","Type":"Logo_Type__1ST8Q"};